var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3bda6475068dec793ee12b80b4501ef73f006251"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yunnanzhiye-pc-web"]={id:"3bda6475068dec793ee12b80b4501ef73f006251"};
      